export const PASSPORT_MASK = 'aa 9999999'
export const DATE_MASK = '99.99.9999'
export const PHONE_MASK = '+\\9\\98 (99) 999-99-99'
